import React, { Suspense } from 'react';
import { Route, Routes, useLocation, useMatch } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import { AuthRouter } from '../routers/auth.router';
import { MainRouter } from '../routers/main.router';

import { ActionPanelProvider, BreadcrumbsProvider, TitleProvider } from '../contexts';

import MainLayout from './Main';
import AuthLayout from './Auth';

const isAuthRoute = () =>
  !!AuthRouter.find(route => {
    return useMatch(route.path);
  });

const Layout = () => {
  const location = useLocation();
  const isAuthPage = isAuthRoute(location.pathname);

  return (
    <Suspense
      fallback={
        <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' flexGrow={1}>
          <CircularProgress />
        </Box>
      }>
      {isAuthPage ? (
        <AuthLayout />
      ) : (
        <Box>
          <TitleProvider>
            <BreadcrumbsProvider>
              <ActionPanelProvider>
                <Routes>
                  {MainRouter.map((router, idx) => {
                    return (
                      <Route
                        path={router?.path}
                        exact={router?.exact}
                        key={`${idx}-${router?.name}`}
                        element={<MainLayout Component={router?.component} />}
                      />
                    );
                  })}
                </Routes>
              </ActionPanelProvider>
            </BreadcrumbsProvider>
          </TitleProvider>
        </Box>
      )}
    </Suspense>
  );
};

export default Layout;
